<template>
  <BittsLoading is-loading />
</template>

<script setup lang="ts">
import { BittsLoading } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { crossbeamApi } from '@/api';
import { getAndClearLSNextUrl } from '@/local_storage';
import { usePartnerCloudStore } from '@/stores';
import { useRootStore } from '@/stores/RootStore';

useHead({
  title: 'Slack Callback - Crossbeam',
});

const { loadUserProfile } = useRootStore();
const { refreshPartnerCloudStore } = usePartnerCloudStore();

const route = useRoute();
const router = useRouter();

onMounted(async () => {
  const query = {
    code: String(route.query.code),
    state: String(route.query.state),
  };
  // Successful OAuth
  if (query.code) {
    await crossbeamApi.POST('/public/v0.1/slack/auth/success', {
      params: {
        query,
      },
    });
    await Promise.all([loadUserProfile(), refreshPartnerCloudStore()]);
  }

  const nextFromLS = getAndClearLSNextUrl();
  router.push(nextFromLS || { name: 'integrations' });
});
</script>
